(function () {
  class ReelSpinnerVisualSCS extends SlotsEngine.types.ReelSpinnerVisual {
    constructor(
      reelId,
      name,
      maxAppertureHeight,
      slotMach,
      minSpacing,
      reservedSpace,
      numPreapp,
      numPostapp
    ) {
      super(
        reelId,
        name,
        maxAppertureHeight,
        slotMach,
        minSpacing,
        reservedSpace,
        numPreapp,
        numPostapp
      );

      this._fireballMovies = [];
      this._fireballCashOverlays = [];
      this._fireballPotOverlays = [];
      this._blueFireballWildOverlays = [];
      this._fireballsAreBlue = false;
      this._showBlueFireballWild = false;
    }

    createFireballMovies() {
      let totalAppertureSize =
        this.getReelSpinnerData().getTotalAppertureSize();
      for (let i = 0; i < totalAppertureSize; ++i) {
        let gfxObject = this._symbolGfxObjects[i];

        let fireball = resourceManager.createObject(
          "movie",
          "Symbol_Fireball",
          gfxObject.symbol.childContainer,
          {
            definition: "Symbol_Fireball",
            anchor: 0.5,
          }
        );
        fireball.visible = false;
        //fireball.gotoAndStop(0);

        let bluefireball = resourceManager.createObject(
          "movie",
          "Symbol_BlueFireball",
          gfxObject.symbol.childContainer,
          {
            definition: "Symbol_Wild",
            anchor: 0.5,
          }
        );
        bluefireball.visible = false;
        //bluefireball.gotoAndStop(0);

        let pinkfireball = resourceManager.createObject(
          "movie",
          "Symbol_Fireball_Pink",
          gfxObject.symbol.childContainer,
          {
            definition: "Symbol_Fireball_Pink",
            anchor: 0.5,
          }
        );
        pinkfireball.visible = false;
        //pinkfireball.gotoAndStop(0);

        this._fireballMovies.push({ fireball, bluefireball, pinkfireball });
      }
    }

    createFireballCashOverlays() {
      let totalAppertureSize =
        this.getReelSpinnerData().getTotalAppertureSize();
      for (let i = 0; i < totalAppertureSize; ++i) {
        let gfxObject = this._symbolGfxObjects[i];
        let overlay = resourceManager.createObject(
          "text",
          "fireballCashOverlay",
          gfxObject.symbol.childContainer,
          {
            text: "???",
            fontDefinition: "whiteGlow",
            fontSize: 34,
            maxWidth: 140,
            anchor: 0.5,
          }
        );
        overlay.visible = false;
        this._fireballCashOverlays.push(overlay);
      }
    }

    createFireballPotOverlays() {
      let totalAppertureSize =
        this.getReelSpinnerData().getTotalAppertureSize();
      for (let i = 0; i < totalAppertureSize; ++i) {
        let gfxObject = this._symbolGfxObjects[i];

        let miniOverlay = resourceManager.createObject(
          "sprite",
          "fireballPotMiniOverlay",
          gfxObject.symbol.childContainer,
          {
            fileName: "potBonus/Fireball_MINI.png",
            anchor: 0.5,
          }
        );
        miniOverlay.visible = false;
        let minorOverlay = resourceManager.createObject(
          "sprite",
          "fireballPotMinorOverlay",
          gfxObject.symbol.childContainer,
          {
            fileName: "potBonus/Fireball_MINOR.png",
            anchor: 0.5,
          }
        );
        minorOverlay.visible = false;
        let majorOverlay = resourceManager.createObject(
          "sprite",
          "fireballPotMajorOverlay",
          gfxObject.symbol.childContainer,
          {
            fileName: "potBonus/Fireball_MAJOR.png",
            anchor: 0.5,
          }
        );
        majorOverlay.visible = false;
        let megaOverlay = resourceManager.createObject(
          "sprite",
          "fireballPotMegaOverlay",
          gfxObject.symbol.childContainer,
          {
            fileName: "potBonus/Fireball_MEGA.png",
            anchor: 0.5,
          }
        );
        megaOverlay.visible = false;

        this._fireballPotOverlays.push({
          mini: miniOverlay,
          minor: minorOverlay,
          major: majorOverlay,
          mega: megaOverlay,
        });
      }
    }

    createBlueFireballWildOverlays() {
      let totalAppertureSize =
        this.getReelSpinnerData().getTotalAppertureSize();
      for (let i = 0; i < totalAppertureSize; ++i) {
        let gfxObject = this._symbolGfxObjects[i];

        let overlay = resourceManager.createObject(
          "sprite",
          "wildOverlay",
          gfxObject.symbol.childContainer,
          {
            fileName: "wildFire/Wild_Txt.png",
            anchor: 0.5,
          }
        );
        overlay.visible = false;

        this._blueFireballWildOverlays.push(overlay);
      }
    }

    turnFireballsBlue(blue) {
      this._fireballsAreBlue = blue;
    }

    showBlueFireballWild(show) {
      this._showBlueFireballWild = show;
    }

    showFireballMovie(i, show, forceBlue) {
      if (show) {
        if (this._fireballsAreBlue || forceBlue) {
          this._fireballMovies[i].fireball.visible = !show;
          this._fireballMovies[i].bluefireball.visible = show;
        } else {
          this._fireballMovies[i].bluefireball.visible = !show;
          this._fireballMovies[i].fireball.visible = show;
        }
      } else {
        this._fireballMovies[i].bluefireball.visible = false;
        this._fireballMovies[i].fireball.visible = false;
      }
    }

    showPinkFireballMovie(i, show) {
      if (show) {
        this._fireballMovies[i].bluefireball.visible = !show;
        this._fireballMovies[i].fireball.visible = !show;
        this._fireballMovies[i].pinkfireball.visible = show;
      } else {
        this._fireballMovies[i].bluefireball.visible = false;
        this._fireballMovies[i].fireball.visible = false;
        this._fireballMovies[i].pinkfireball.visible = false;
      }
    }

    bounceOverlays() {
      let self = this;
      timerManager.addTimer(
        300,
        function (progress) {
          let newScale = 1 + 0.2 * Math.abs(Math.sin(Math.PI * progress));
          self._fireballCashOverlays[0].scale.set(newScale, newScale);

          self._fireballPotOverlays[0].mini.scale.set(newScale, newScale);
          self._fireballPotOverlays[0].minor.scale.set(newScale, newScale);
          self._fireballPotOverlays[0].major.scale.set(newScale, newScale);
          self._fireballPotOverlays[0].mega.scale.set(newScale, newScale);
        },
        function () {
          self._fireballCashOverlays[0].scale.set(1, 1);

          self._fireballPotOverlays[0].mini.scale.set(1, 1);
          self._fireballPotOverlays[0].minor.scale.set(1, 1);
          self._fireballPotOverlays[0].major.scale.set(1, 1);
          self._fireballPotOverlays[0].mega.scale.set(1, 1);
        }
      );
    }

    updateSymbolIds(ids) {
      super.updateSymbolIds(ids);

      const symbols = resourceManager.getConfiguration().symbols;

      const possibleCashValues = [20, 40, 60, 80, 100, 200, 300, 400, 400];
      const firstCashFireballId = symbols["Symbol_Fireball20"].ID;
      const firstCashBlueFireballId = symbols["Symbol_BlueFireball20"].ID;

      let stake = gameController.getCurrentModeStake(true);

      for (let i = 0; i < ids.length; ++i) {
        this._fireballCashOverlays[i].visible = false;
        this.showFireballMovie(i, false);
        this.showPinkFireballMovie(i, false);
        this._fireballPotOverlays[i].mini.visible = false;
        this._fireballPotOverlays[i].minor.visible = false;
        this._fireballPotOverlays[i].major.visible = false;
        this._fireballPotOverlays[i].mega.visible = false;
        this._blueFireballWildOverlays[i].visible = false;

        let symId = ids[i];

        switch (symId) {
          case symbols["Symbol_Fireball20"].ID:
          case symbols["Symbol_Fireball40"].ID:
          case symbols["Symbol_Fireball60"].ID:
          case symbols["Symbol_Fireball80"].ID:
          case symbols["Symbol_Fireball100"].ID:
          case symbols["Symbol_Fireball200"].ID:
          case symbols["Symbol_Fireball300"].ID:
          case symbols["Symbol_Fireball400"].ID:
          case symbols["Symbol_Fireball500"].ID: {
            const baseVal = possibleCashValues[symId - firstCashFireballId];
            const value = baseVal * (stake / gameData.numLines);
            this.showFireballMovie(i, true);
            this._fireballCashOverlays[i].visible = true;
            this._fireballCashOverlays[i].setText(gdk.formatCurrency(value));
            break;
          }
          case symbols["Symbol_FireballX2"].ID: {
            this.showPinkFireballMovie(i, true);
            this._fireballCashOverlays[i].visible = true;
            this._fireballCashOverlays[i].setText("");
            break;
          }
          case symbols["Symbol_BlueFireball20"].ID:
          case symbols["Symbol_BlueFireball40"].ID:
          case symbols["Symbol_BlueFireball60"].ID:
          case symbols["Symbol_BlueFireball80"].ID:
          case symbols["Symbol_BlueFireball100"].ID:
          case symbols["Symbol_BlueFireball200"].ID:
          case symbols["Symbol_BlueFireball300"].ID:
          case symbols["Symbol_BlueFireball400"].ID:
          case symbols["Symbol_BlueFireball500"].ID: {
            if (this._showBlueFireballWild) {
              this._blueFireballWildOverlays[i].visible = true;
            } else {
              const baseVal =
                possibleCashValues[symId - firstCashBlueFireballId];
              const value = baseVal * (stake / gameData.numLines);
              this._fireballCashOverlays[i].visible = true;
              this._fireballCashOverlays[i].setText(gdk.formatCurrency(value));
            }
            this.showFireballMovie(i, true, true);
            break;
          }
          case symbols["Symbol_FireballMini"].ID: {
            this.showFireballMovie(i, true);
            this._fireballPotOverlays[i].mini.visible = true;
            break;
          }
          case symbols["Symbol_FireballMinor"].ID: {
            this.showFireballMovie(i, true);
            this._fireballPotOverlays[i].minor.visible = true;
            break;
          }
          case symbols["Symbol_FireballMajor"].ID: {
            this.showFireballMovie(i, true);
            this._fireballPotOverlays[i].major.visible = true;
            break;
          }
          case symbols["Symbol_FireballMega"].ID: {
            this.showFireballMovie(i, true);
            this._fireballPotOverlays[i].mega.visible = true;
            break;
          }
          case symbols["Symbol_BlueFireballMini"].ID: {
            this.showFireballMovie(i, true, true);
            if (this._showBlueFireballWild) {
              this._blueFireballWildOverlays[i].visible = true;
            } else {
              this._fireballPotOverlays[i].mini.visible = true;
            }
            break;
          }
          case symbols["Symbol_BlueFireballMinor"].ID: {
            this.showFireballMovie(i, true, true);
            if (this._showBlueFireballWild) {
              this._blueFireballWildOverlays[i].visible = true;
            } else {
              this._fireballPotOverlays[i].minor.visible = true;
            }
            break;
          }
          case symbols["Symbol_BlueFireballMajor"].ID: {
            this.showFireballMovie(i, true, true);
            if (this._showBlueFireballWild) {
              this._blueFireballWildOverlays[i].visible = true;
            } else {
              this._fireballPotOverlays[i].major.visible = true;
            }
            break;
          }
          case symbols["Symbol_BlueFireballMega"].ID: {
            this.showFireballMovie(i, true, true);
            if (this._showBlueFireballWild) {
              this._blueFireballWildOverlays[i].visible = true;
            } else {
              this._fireballPotOverlays[i].mega.visible = true;
            }
            break;
          }
        }
      }
    }
  }

  function create(json) {
    let numPreapp = json.numPreappertureSymbols || 2;
    let numPostapp = json.numPostappertureSymbols || 2;
    return new ReelSpinnerVisualSCS(
      json.ID,
      json.ID + " container",
      json.appertureHeight,
      json.slotMachineName,
      json.minSymbolSpacing,
      1,
      numPreapp,
      numPostapp
    );
  }

  function initialise(json, reelSpinnerVisual) {
    reelSpinnerVisual.initialise(json);
    reelSpinnerVisual.createFireballMovies();
    reelSpinnerVisual.createBlueFireballWildOverlays();
    reelSpinnerVisual.createFireballCashOverlays();
    reelSpinnerVisual.createFireballPotOverlays();
  }

  function getRequiredFiles() {
    return [];
  }

  resourceManager.registerObjectType(
    "ReelSpinnerVisualSCS",
    create,
    initialise,
    getRequiredFiles
  );
})();
